<template>
  <svg
    :class="size"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42" cy="42" r="42" fill="#00EF8B" />
    <path d="M58.7936 35.5469H48.4536V45.8869H58.7936V35.5469Z" fill="white" />
    <path
      d="M38.1133 49.7735C38.1133 51.9002 36.3533 53.6602 34.2267 53.6602C32.1 53.6602 30.34 51.9002 30.34 49.7735C30.34 47.6469 32.1 45.8869 34.2267 45.8869H38.1133V35.5469H34.2267C26.38 35.5469 20 41.9269 20 49.7735C20 57.6202 26.38 64.0002 34.2267 64.0002C42.0733 64.0002 48.4533 57.6202 48.4533 49.7735V45.8869H38.1133V49.7735Z"
      fill="white"
    />
    <path
      d="M48.4533 35.5469H38.1133V45.8869H48.4533V35.5469Z"
      fill="#00EF8B"
    />
    <path
      d="M52.3399 30.34H64V20H52.3399C44.4933 20 38.1133 26.38 38.1133 34.2267V35.5467H48.4533V34.2267C48.4533 32.1 50.2133 30.34 52.3399 30.34Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
